import { useState, useMemo } from "react";
import type { TemplateInformation } from "../../types/api-types";

const useTemplateFilters = (templates: TemplateInformation[]) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [validatorFilter, setValidatorFilter] = useState<"all" | "yes" | "no">(
    "all",
  );

  const filteredTemplates = useMemo(() => {
    return templates.filter((template) => {
      const matchesSearch = template.description
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase());
      const matchesValidator =
        validatorFilter === "all" ||
        (validatorFilter === "yes" && template.useDataValidator) ||
        (validatorFilter === "no" && !template.useDataValidator);

      return matchesSearch && matchesValidator;
    });
  }, [templates, searchTerm, validatorFilter]);

  return {
    searchTerm,
    setSearchTerm,
    validatorFilter,
    setValidatorFilter,
    filteredTemplates,
  };
};

export default useTemplateFilters;
